import { Text } from '@pukka/ui-components';

import searchImg from './assets/illustration-search.svg';

function BrandsNoData({ title, description }: { title: string; description: string }) {
  return (
    <div className="m-auto flex w-full flex-col items-center pt-12 text-center">
      <img src={searchImg} alt="Not Found" />
      <Text variant="title-1" weight="bold" className="mb-4 mt-6">
        {title}
      </Text>
      <Text variant="body-1">{description}</Text>
    </div>
  );
}

export { BrandsNoData };
